import ReactECharts from "echarts-for-react";

interface BarItem {
  name: string;
  value: number;
}

interface VerticalBarProps {
  data: BarItem[];
  color?: string;
  height?: number;
}

export function VerticalBar({
  data,
  color = "#00553E",
  height = 260,
}: VerticalBarProps) {
  const option = {
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    grid: { left: 40, right: 16, top: 16, bottom: 60 },
    xAxis: {
      type: "category",
      data: data.map((d) => d.name),
      axisLabel: { rotate: 30, fontSize: 10, overflow: "truncate", width: 80 },
      axisLine: { show: false },
      axisTick: { show: false },
    },
    yAxis: {
      type: "value",
      axisLine: { show: false },
      splitLine: { lineStyle: { type: "dashed", opacity: 0.4 } },
    },
    color: [color],
    series: [
      {
        type: "bar",
        data: data.map((d) => d.value),
        barMaxWidth: 32,
        itemStyle: { borderRadius: [4, 4, 0, 0] },
        label: { show: true, position: "top", fontSize: 11 },
      },
    ],
  };

  return (
    <ReactECharts option={option} style={{ width: "100%", height }} notMerge />
  );
}
